/**
 * Sugestões de produtos na gaveta do carrinho — Use Papoula
 *
 * Consulta a API de recomendações do Shopify usando o primeiro item real do
 * carrinho como âncora. Tenta "complementary" (curadoria feita no app Search &
 * Discovery) e cai para "related" (automático) quando não há curadoria.
 *
 * Regras de exclusão, nesta ordem:
 *   - componentes de letra (tag "componente-letra"): nunca aparecem;
 *   - o que já está no carrinho;
 *   - produtos esgotados.
 *
 * Peças personalizadas (tag "personalizado") aparecem, mas com link para a
 * página do produto em vez de botão de adicionar: elas exigem a escolha da
 * letra, e um add direto criaria pedido sem letra e sem baixa de estoque.
 *
 * ATENÇÃO: essa proteção depende da tag "personalizado" continuar nas 4 peças
 * com letra. Se a tag sair, o produto vira adicionável sem letra.
 */
(function () {
  'use strict';

  var LIMITE = 6;
  var MOSTRAR = 3;

  var rotas = (window.Theme && window.Theme.routes) || {};
  var urlCart = rotas.cart_url || '/cart';
  var urlAdd = rotas.cart_add_url || '/cart/add';

  function temTag(produto, tag) {
    return (produto.tags || []).some(function (t) {
      return String(t).toLowerCase() === tag;
    });
  }

  /** Usa o formato de moeda da loja, senão o preço sai "99.00" em vez de "R$ 99,00". */
  function dinheiro(centavos) {
    var bloco = document.querySelector('[data-cart-recommendations]');
    var formato = (bloco && bloco.dataset.moneyFormat) || 'R$ {{amount_with_comma_separator}}';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(centavos, formato);
    }
    return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',');
  }

  function lerCarrinho() {
    return fetch(urlCart + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  function recomendacoes(produtoId, intencao) {
    var url =
      '/recommendations/products.json?product_id=' + produtoId +
      '&intent=' + intencao + '&limit=' + LIMITE;
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { return d.products || []; })
      .catch(function () { return []; });
  }

  /** Sugestões para o carrinho atual, já filtradas. */
  function sugestoes(carrinho) {
    var reais = carrinho.items.filter(function (i) {
      return !(i.properties && i.properties._papoula_grupo && !i.properties.Letras);
    });
    if (reais.length === 0) return Promise.resolve([]);

    var ancora = reais[0].product_id;
    var jaNoCarrinho = {};
    carrinho.items.forEach(function (i) { jaNoCarrinho[i.product_id] = true; });

    return recomendacoes(ancora, 'complementary')
      .then(function (lista) {
        // Sem curadoria no Search & Discovery, usa o automático.
        return lista.length > 0 ? lista : recomendacoes(ancora, 'related');
      })
      .then(function (lista) {
        return lista
          .filter(function (p) { return !temTag(p, 'componente-letra'); })
          .filter(function (p) { return !jaNoCarrinho[p.id]; })
          .filter(function (p) { return p.available; })
          .slice(0, MOSTRAR);
      });
  }

  function cartao(produto) {
    var personalizado = temTag(produto, 'personalizado');
    var img = produto.featured_image || (produto.images && produto.images[0]) || '';
    var thumb = img ? img.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';

    var acao = personalizado
      ? '<a class="cart-recs__btn" href="' + produto.url + '">Escolher letra</a>'
      : '<button type="button" class="cart-recs__btn" data-cart-recs-add="' +
        produto.variants[0].id + '">Adicionar</button>';

    return (
      '<div class="cart-recs__item">' +
      (thumb ? '<img class="cart-recs__img" src="' + thumb + '" alt="" loading="lazy" width="60" height="60">' : '') +
      '<div class="cart-recs__info">' +
      '<a class="cart-recs__name" href="' + produto.url + '">' + produto.title + '</a>' +
      '<span class="cart-recs__price">' + dinheiro(produto.price) + '</span>' +
      '</div>' +
      acao +
      '</div>'
    );
  }

  function render() {
    var bloco = document.querySelector('[data-cart-recommendations]');
    var lista = document.querySelector('[data-cart-recommendations-list]');
    if (!bloco || !lista) return;

    lerCarrinho()
      .then(sugestoes)
      .then(function (produtos) {
        if (produtos.length === 0) {
          bloco.hidden = true;
          lista.innerHTML = '';
          return;
        }
        lista.innerHTML = produtos.map(cartao).join('');
        bloco.hidden = false;
      })
      .catch(function () {
        bloco.hidden = true;
      });
  }

  /**
   * Recarrega o conteúdo da gaveta do jeito que o tema faz, buscando
   * /cart?view=mini e trocando o HTML do container aberto.
   */
  function recarregarGaveta() {
    return fetch(urlCart + '?view=mini', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var novo = doc.querySelector('template[data-html="content"]');
        var destino = document.querySelector('[data-sidebar-drawer-content]');
        if (novo && destino) destino.innerHTML = novo.innerHTML;
      });
  }

  // --- Adicionar a partir da gaveta ---------------------------------------

  document.addEventListener('click', function (evento) {
    var botao = evento.target.closest('[data-cart-recs-add]');
    if (!botao) return;

    evento.preventDefault();
    if (botao.disabled) return;

    botao.disabled = true;
    botao.textContent = 'Adicionando...';

    fetch(urlAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: parseInt(botao.dataset.cartRecsAdd, 10), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('falha ao adicionar');
        return recarregarGaveta();
      })
      .then(function () {
        // O contador do header é corrigido pelo observador do cart-letters.js.
        document.querySelectorAll('[data-cart-mini-count]').forEach(function (el) {
          el.textContent = el.textContent;
        });
        render();
      })
      .catch(function () {
        botao.disabled = false;
        botao.textContent = 'Tentar de novo';
      });
  });

  // --- Renderiza sempre que a gaveta é (re)desenhada -----------------------

  function observarGaveta() {
    var destino = document.querySelector('[data-sidebar-drawer-content]');
    if (!destino) return;

    var agendado = null;
    new MutationObserver(function () {
      clearTimeout(agendado);
      agendado = setTimeout(render, 60);
    }).observe(destino, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observarGaveta);
  } else {
    observarGaveta();
  }
})();
